import './style.css';
import {OPTIONS} from '../../data/Clients';
import { useForm } from "react-hook-form";

function BudgetForm(){
    const { register, handleSubmit, errors } = useForm();

    //validar que los campos estén correctos
    function onSubmit(data, e){
        e.preventDefault();
        //datos ingresados:
        console.log(data);
    }

    return <form className="budget-form-wrapper" onSubmit={handleSubmit(onSubmit)}>
        <legend className="budget-form-legend">Tus datos</legend>
        <div className="budget-form-container">
            <div className="budget-form-row">
                <input className="form-input" placeholder="Nombre*" name="nombre" ref={register({required: true})}/>
                <input className="form-input"  placeholder="Apellido*" name="apellido" ref={register({required: true})}/>
                <input className="form-input" placeholder="E-mail*" name="e-mail" ref={register({required: true})}/>
            </div>
            <div className="budget-form-row">
                <input className="form-input" placeholder="Teléfono*" name="telefono" ref={register({required: true})}/>
                <select className="form-input" name="cliente" ref={register({required: true})}>
                    {OPTIONS.map(op => <option value={op.key}>{op.value}</option>)}
                </select>
                <input  className="form-input" placeholder="Nombre de la empresa (Opcional)" name="nombre-de-empresa" ref={register({required: false})}/>
            </div>
        </div>
        <legend className="budget-form-legend">Selección de entrega</legend>
        <div className="budget-form-container">
            <div className="budget-form-row">
                <input className="form-input" placeholder="Calle*" name="calle" ref={register({required: true})}/>
                <input className="form-input" placeholder="Número*" name="numero" ref={register({required: true})}/>
                <input className="form-input" placeholder="Entrecalles*" name="entrecalles" ref={register({required: true})}/>
            </div>
            <div className="budget-form-row">
                <input className="form-input" placeholder="Barrio*" name="barrio" ref={register({required: true})}/>
                <input className="form-input" placeholder="Localidad/Ciudad*" name="ciudad" ref={register({required: true})}/>
                <input className="form-input" placeholder="Código Postal*" name="codigo-postal" ref={register({required: true})}/>
            </div>
        </div>
        <legend className="budget-form-legend">Completá tu pedido</legend>
        <textarea className="form-textarea budget-form-textarea" placeholder="Para poder brindarte un mejor servicio, completalo lo más detallado posible"></textarea>
        <button className="submit-btn budget-form-btn">Enviar</button>
        {Object.keys(errors).includes('nombre','apellido', 'e-mail', 'telefono', 'cliente', 'calle', 'numero', 'entrecalles', 'barrio', 'ciudad', 'codigo-postal') && 
            <div className="error-container">
                <p><span className="error-alert">¡Error!</span> Uno o más campos de texto no han sido completados correctamente, por favor revisalos y probá de nuevo.</p>
            </div>}
        
    </form>
}

export default BudgetForm;